"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheKeystoneStandard() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="98620" id="architectural-integrity" className="dark bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`w-full lg:w-3/5 transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative aspect-[4/5] md:aspect-[16/10] lg:aspect-[4/3] w-full overflow-hidden border border-border shadow-2xl bg-muted">
              {}
              <div className="absolute inset-0 border-[0.5px] border-primary/20 m-4 pointer-events-none z-10" />
              <div className="absolute top-0 left-0 w-16 h-16 border-t border-l border-primary/50 m-4 pointer-events-none z-10" />
              <div className="absolute bottom-0 right-0 w-16 h-16 border-b border-r border-primary/50 m-4 pointer-events-none z-10" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/keystone_founding_partner_portrait.png" alt="Managing Director of Century Pointe Holdings" className="object-cover w-full h-full filter grayscale-[20%] contrast-125" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`w-full lg:w-2/5 flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="flex items-center gap-4 mb-8">
              <div className="h-[1px] w-12 bg-primary shadow-[0_0_8px_rgba(0,255,255,0.5)]" />
              <span className="text-sm font-mono tracking-widest text-primary uppercase">
                The Foundation
              </span>
            </div>

            <h2 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-foreground mb-8 leading-tight">
              Architectural <br className="hidden lg:block" />
              <span className="text-primary">Precision.</span>
            </h2>

            <div className="space-y-6 text-lg text-muted-foreground leading-loose font-sans">
              <p>
                Century Pointe Holdings is a specialized professional services firm dedicated to technological optimization and strategic business advisory. Established to provide technical oversight, we deliver high-level consulting that streamlines digital workflows and internal infrastructures.
              </p>
              <p>
                Our systematic approach to organizational efficiency ensures that every technical framework is engineered for scalability and resilience. We believe that modern performance is built on a foundation of structural integrity, deep technical expertise, and precise strategic execution.
              </p>
            </div>

            <div className="mt-16 pt-8 border-t border-border/50">
              {}
              <svg width="200" height="60" viewBox="0 0 200 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-primary opacity-80">
                <path d="M15 45C15 45 22 25 35 15C48 5 55 20 50 35C45 50 30 55 25 45C20 35 35 25 50 20C65 15 80 30 85 40C90 50 85 55 75 50C65 45 70 30 85 25C100 20 115 35 120 45C125 55 120 60 110 55C100 50 105 35 120 30C135 25 150 40 155 50C160 60 155 65 145 60C135 55 140 40 155 35C170 30 185 45 190 55" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="path-draw" />
                <path d="M40 30L180 30" stroke="currentColor" strokeWidth="1" strokeDasharray="4 4" className="opacity-20" />
              </svg>
              <div className="mt-4">
                <p className="font-sans font-bold text-xl text-foreground">Marcus Sterling</p>
                <p className="text-sm text-muted-foreground font-mono tracking-wide uppercase mt-1">
                  Managing Director
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}